<template>
  <header-title />
  <div class="container">
    <aside-body />
    <div class="main">
      <el-tabs type="border-card" style="margin-top: 30px; margin-left: 30px">
        <el-tab-pane label="结果信息">
          <!-- <div class="form" v-for="(item, index) in asks" :key="index">
          <div class="ask">{{ item.title.t_name }}</div>
          <el-radio-group v-model="item.title.selected">
            <el-radio v-for="(item1, index1) in item.title.t_options" :key="index1" :label="index1">{{ item1
              }}</el-radio>
          </el-radio-group>
        </div> -->
          <div class="form" v-for="(item, index) in asks" :key="index">
            <div class="askTitle">{{ item.t_name }}</div>
            <div class="answerBox">
              <div class="answer" v-for="(item1, index1) in item.t_options" :key="index1">
                {{ item1.a_persons }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="参与人信息">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="name" label="姓名" width="180" />
            <el-table-column prop="phone" label="联系方式" width="210" />
            <el-table-column prop="date" label="填写时间" width="210" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import headerTitle from '@/components/headerTitle.vue'
import asideBody from '@/components/asideBody.vue'
// import http from '@/util/http'

export default {
  name: 'resultView',
  components: { asideBody, headerTitle },
  data () {
    return {
      list: [],
      asks: [
        {
          t_id: '2255',
          t_name: '问1',
          t_options: [
            { a_persons: '1', a_id: 1 },
            { a_persons: '2', a_id: 2 },
            { a_persons: '3', a_id: 3 },
            { a_persons: '4', a_id: 4 }
          ]
        },
        {
          t_id: '2255',
          t_name: '问2',
          t_options: [
            { a_persons: '1', a_id: 1 },
            { a_persons: '2', a_id: 2 },
            { a_persons: '3', a_id: 3 },
            { a_persons: '4', a_id: 4 }
          ]
        }
      ],
      tableData: [
        {
          date: '2016-05-03',
          name: 'Tom',
          phone: '13312341234'
        },
        {
          date: '2016-05-02',
          name: 'Tom',
          phone: '13312341234'
        },
        {
          date: '2016-05-04',
          name: 'Tom',
          phone: '13312341234'
        },
        {
          date: '2016-05-01',
          name: 'Tom',
          phone: '13312341234'
        }
      ]
    }
  },
  methods: {
    _getResId () {
      // const queryId = this.$route.query.id;
      // http.get('selectOptionsNum/').then((res) => {
      //   if (res.data.code == 200) {
      //     this.list = res.data.data.list
      //   }
      // })
    }
  }
}
</script>

<style scoped>
.answerBox {
  display: flex;
  justify-content: space-between;
  /* flex-wrap: wrap; */
}

/* .answer {
  flex-basis: calc(50% - 10px);
  box-sizing: border-box;
  margin: 5px;
  width: 100%;
} */
</style>
